
import { defineComponent, reactive } from "vue";
import {
  barriers as barriersData,
  barrierMap,
  Barriers
} from "@/const/barriers";
import { useStore } from "@/store";
import { SysInfo } from "@/const/sys";
import { SysActionTypes } from "@/store/sys/action-types";
import { confirm } from "@/util/confirm";
const store = useStore();
const MapBarriers = defineComponent({
  setup(props, context) {
    const barriers = reactive(barriersData);
    const degreeType = reactive(barrierMap.degree);
    const barriserDegree = (averageLevel: number) => {
      // 更具穿戴装备平均等级(单件等级) 和 关卡预设难度等级 差值 体现副本难度, 范围 0 - 4
      const difLevel = averageLevel - store.getters.wearEquipAverageLevel;
      return Math.min(Math.max(difLevel, 0), 4);
    };
    const showBarriers = ({ name, averageLevel }: Barriers) => {
      const title = `副本：${name}\r\n难度：${
        degreeType[barriserDegree(averageLevel)]
      }\r\n推荐装等：${averageLevel}级`;
      return title;
    };
    const handleBattle = async ({
      name,
      id,
      position,
      averageLevel
    }: Barriers) => {
      const res = await confirm(`前方危险，是否前往${name}`);
      if (res) {
        store.dispatch(
          SysActionTypes.SYS_PUSH_INFO,
          new SysInfo(
            `开启战斗：${name}，难度：${
              degreeType[barriserDegree(averageLevel)]
            }`,
            4
          )
        );
        context.emit("startbattle", id);
        context.emit("changecurrentp", position);
      }
    };

    return {
      barriers,
      showBarriers,
      handleBattle,
      barriserDegree
    };
  }
});
export type MapBarriersRefs = InstanceType<typeof MapBarriers>;
export default MapBarriers;
